<template>
  <div style="width: 100%;height: 100%; background-color: #FFFFFF; overflow: auto">
    <el-container>
      <el-header style="height: 50px">设备列表</el-header>
      <el-main style="background-color: #ffffff;">
        <el-input class="mb-1"
          placeholder="输入关键字搜索"
          v-model="filterText">
        </el-input>
        <div class="device-tree-main-box">
          <el-tree ref="tree" :data="treeData" :filter-node-method="filterNode" @node-click="handleNodeClick" style="min-width: 100%; display:inline-block !important;">
            <span class="custom-tree-node" slot-scope="{ node, data }">
            <span style="font-size: 14px">{{ node.label }}</span>
            <span>
               <el-tooltip v-if="data.type == 'ship'" style="margin:4px;" effect="dark" content="船舶统计" placement="top">
                <i class="el-icon-s-data" @click.stop="() => clickShipEvent(data)"></i>
              </el-tooltip>
              <el-tooltip v-if="data.type == 'video'" style="margin:4px;" effect="dark" content="监控回放" placement="top">
                <i class="el-icon-video-camera-solid" @click.stop="() => clickPlayBackEvent(data)"></i>
              </el-tooltip>
<!--              <el-button-->
<!--                v-if="data.type == 'video'"-->
<!--                type="text"-->
<!--                size="mini"-->
<!--                @click.stop="() => clickPlayBackEvent(data)">-->
<!--                查看回放-->
<!--              </el-button>-->
            </span>
          </span>
          </el-tree>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import DeviceService from "../service/DeviceService.js";

export default {
    name: 'DeviceTree',
    data() {
        return {
          deviceService: new DeviceService(),
          treeData: [],
          defaultProps: {
            children: 'children',
            label: 'name',
            isLeaf: 'isLeaf'
          },
          filterText: '',
        };
    },
    props: ['clickEvent', 'contextMenuEvent','clickPlayBackEvent','clickShipEvent'],
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
        if(sessionStorage.getItem("shipName") && sessionStorage.getItem("shipName")!='undefined'){
          for(let i=0;i<this.treeData.length;i++){
            let node = this.treeData[i].children.filter(s=>s.label == val)
            if(node){
              this.handleNodeClick(node[0])
              break
            }
          }
        }
      }
    },
    created(){
      let that = this;
      this.getTreeData();
      window.addEventListener('setItem', () => {
          that.$nextTick(()=> {
            that.filterText = sessionStorage.getItem("shipName")
          })
      })
    },
  methods: {
      getTreeData(){
        let that = this;
        this.$axios({ method: 'get', url:`/api/video/treeList` }).then(function (res) {
          that.treeData = res.data.data;
          that.$nextTick(()=>{
            if(sessionStorage.getItem("shipName") && sessionStorage.getItem("shipName")!='undefined'){
              that.filterText = sessionStorage.getItem("shipName")
            }
          })
        }).catch(function (error) {
          console.log(error);
        });
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      handleNodeClick(data,node,element) {
        if(typeof (this.clickEvent) == "function") {
          if(data.type == "video" || data.type == "ship"){
            this.clickEvent(data)
          }
        }
      },
      handleContextMenu(event,data,node,element) {
        console.log("右键点击事件")
        if(typeof (this.contextMenuEvent) == "function") {
          this.contextMenuEvent(event, data.userData)
        }
      },
    },
    destroyed() {
      // if (this.jessibuca) {
      //   this.jessibuca.destroy();
      // }
      // this.playing = false;
      // this.loaded = false;
      // this.performance = "";
    },
}
</script>

<style>
.device-tree-main-box{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DeviceTree.vue